import { capitalize } from 'lodash';

// ----------------------------------------------------------------------

function getFirstCharacter(name) {
  return capitalize(name && name.charAt(0));
}

// Avatars use the brand primary so they read as part of the theme and follow the active color
// preset, instead of a per-name semantic color (which looked disconnected from the brand).
export default function createAvatar(name) {
  return {
    name: getFirstCharacter(name),
    color: 'primary',
  };
}
